export default __webpack_public_path__ + "static/media/NoteTaking.b5bc83ae.PNG";